import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription, debounceTime, distinctUntilChanged, pipe } from 'rxjs';
import { AppConstant } from 'src/app/helper/class/app-constant';
import { cloneData, createSearchTableQuery, isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { tblFilterQuery, ResponseData } from 'src/app/helper/interface/response';

@Component({
  selector: 'dataview',
  templateUrl: './dataview.component.html',
  styleUrl: './dataview.component.scss'
})
export class DataviewComponent {

  @Input() parentGetList: ((args?: any) => Promise<any>) | any;
  @Input() templateRef!: TemplateRef<any>;
  layout: 'list' | 'grid' = 'list';
  loader: boolean = false
  @Input() dataViewConfig: any = {};
  @Output() onDatePicked = new EventEmitter<any>();

  data: any = [];
  totalRecords: number = 0;
  lastFilter: any = [];
  rows = AppConstant.TABLE_PAGE_ROWS
  searchControl: UntypedFormControl = {} as UntypedFormControl;
  searchSub: Subscription = {} as Subscription;
  lastSession: any = {};
  currentPage = 0;
  first = 0;
  keyFilter = /^[a-zA-Z0-9\s]*$/;
  dateFilter = /(\d{2})\.(\d{2})\.(\d{4})/;
  date: any;
  totalData: any;
  ngOnInit() {

    this.searchControl = new UntypedFormControl();

  }
  filterByDate(d) {
    this.onDatePicked.emit(d.target.value);

    console.log(d.target.value, 'datae');

  }
  ngAfterViewInit() {
    // server-side search
    if (typeof this.searchSub.unsubscribe == "function") {
      this.searchSub?.unsubscribe();
    }
    this.searchSub = this.searchControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(v => {
      if (v) {
        this.searchData(v);
        console.log('doo');

      } else {
        //on empty
        this.searchData('');
        // this.data = [];
        console.log('undoo');

      }
    })
  }

  restoreLast() {
    console.log('restore session ', this.lastSession)
    if (isEmptyObj(this.lastSession)) {
      this.totalRecords = this.lastSession.totalRecords
      this.data = this.lastSession.data;
      //jum to page 
      // this.first = 0;
    }
  }
  searchData(terms) {
    const where = [{ colName: 'searchTerms', value: terms, matchMode: 'like' }];
    if (isEmptyObj(this.lastSession)) {
      this.lastSession.totalRecords = this.totalRecords;
      this.lastSession.data = this.data;
      this.lastSession.page = this.currentPage;
    }
    this.loadData({ first: 0, rows: this.rows }, where);
  }

  loadData(ev: any = {}, where: any = []) {
    console.log('on load ', ev)
    if (!isEmptyObj(ev)) {
      this.lastFilter = createSearchTableQuery(ev) || {};
    }
    if (where.length) {
      this.lastFilter.queryParams = this.lastFilter.queryParams || [];
      this.lastFilter.queryParams = [...this.lastFilter.queryParams, ...where];
    }
    console.log('after on load ', this.lastFilter)
    this.getData(this.lastFilter);
  }

  getData(ev: tblFilterQuery = {} as tblFilterQuery) {
    this.loader = true;
    this.currentPage = ev.page;
    // this.data=[];
    // ev?.queryParams?.map((a: any) => { if (typeof a.value == 'string') { a.value = a.value.trim() } return a });
    this.parentGetList?.(ev).then((res: ResponseData | any) => {
      if (res?.statusCode == 200) {
        if (this.dataViewConfig?.isLazy) {
          this.data = res.result.data;
          this.totalRecords = res.result.totalRecord;
        } else {
          this.data = res.result;
          this.totalRecords = res.result.length
        }
      }
    }).catch((res: any) => {
      console.warn(res, 'data view Error ');
    }).finally(() => {
      this.loader = false;
    })
  }
  reload() {
    if (!isEmptyObj(this.lastFilter)) {
      this.loadData(this.lastFilter);
    } else {
      this.loadData({});
    }
  }
}
